import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ScarcitySection() {
  return (
    <section className="py-16 bg-[var(--dvx-bg)] transition-colors duration-300">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-[var(--dvx-surface)] border-2 border-[var(--dvx-primary)] p-12 text-center relative overflow-hidden"
        >
          {/* Glow blob */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[200px] bg-[var(--dvx-primary)]/10 blur-[80px] rounded-full pointer-events-none" />

          <div className="relative">
            <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
              Limited Spots
            </span>
            <h2 className="mt-4 font-oswald text-4xl md:text-5xl font-bold text-[var(--dvx-text)] uppercase tracking-tight">
              This Is Not For Everyone
            </h2>
            <p className="mt-4 text-[var(--dvx-text-muted)] font-manrope text-lg max-w-xl mx-auto">
              DVX Coaching is built for committed individuals who want serious physical results, structure, and a premium standard of coaching.
            </p>

            <Link to="/contact">
              <button className="mt-8 px-10 py-4 bg-gradient-to-r from-[var(--dvx-primary)] to-[var(--dvx-primary-dark)] text-white font-oswald font-bold uppercase tracking-widest hover:scale-105 transition-transform flex items-center gap-2 mx-auto">
                Only 10–15 coaching spots available each month <ArrowRight size={18} />
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
